import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { DataProvider } from './context/DataContext';
import SearchPage from './pages/SearchPage';
import ProductDetailPage from './pages/ProductDetailPage';
import LoadingPage from './pages/LoadingPage';

function App() {
  return (
    <DataProvider>
      <Router>
        <Routes>
          <Route path="/" element={<SearchPage />} />
          <Route path="/product/:productId" element={<ProductDetailPage />} />
          <Route path="/loading" element={<LoadingPage />} />
        </Routes>
      </Router>
    </DataProvider>
  );
}

export default App;